<template>
  <div class="nr_container_content mt-60">

    <v-modal-contents ref="modal_contents_successfully" class="modal_contents_successfully">
      <template v-slot:title>
        <div class="terms_of_use__title mt-30 pl-3">
          <div class="h2_title">Ваши ответы приняты</div>
        </div>
      </template>
        <template v-slot:content>
            <div class="terms_of_use mt-30 ">
                <p class="green_messs">Благодарим вас за уделенное время!</p>
            </div>
        </template>
    </v-modal-contents>
    <v-modal-contents ref="modal_alert" class="modal_alert">
      <template v-slot:title>
        <div class="terms_of_use__title mt-30 pl-3 ">
          <div class="h2_title">Уведомление</div>
        </div>
      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <p class="green_messs">Пожалуйста, ответьте на все вопросы.</p>
        </div>
      </template>
    </v-modal-contents>
    <v-form ref="form" v-model="valid" class="poll" :class="validAll ? 'valid':'noValid'">

      <!--      <v-text-field
                v-model="companyName"
                label="Название вашей компании (опционально)"
            ></v-text-field>-->

      <v-radio-group   :rules="rulesFild"
          required="" v-model="cooperationDuration"
                     label="1. Как давно ваша компания сотрудничает с NOVAROLL?">
        <v-radio color="red" label="Менее года" value="Менее года"></v-radio>
        <v-radio color="red" label="1 - 3 года" value="1 - 3 года"></v-radio>
        <v-radio color="red" label="Более 3-х лет" value="Более 3-х лет"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="orderFrequency"
                     label="2. Как часто вы размещаете заказы в NOVAROLL?">
        <v-radio color="red" label="Несколько раз в неделю" value="Несколько раз в неделю"></v-radio>
        <v-radio color="red" label="Раз в неделю" value="Раз в неделю"></v-radio>
        <v-radio color="red" label="Раз в две недели" value="Раз в две недели"></v-radio>
        <v-radio color="red" label="Раз в месяц" value="Раз в месяц"></v-radio>
        <v-radio color="red" label="Реже одного раза в месяц" value="Реже одного раза в месяц"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="orderCycleTime"
                     label="3. Сколько времени занимает весь цикл от момента размещения до получения товара/услуги?">
        <v-radio color="red" label="От 1 до 3 дней" value="От 1 до 3 дней"></v-radio>
        <v-radio color="red" label="От 4 до 7 дней" value="От 4 до 7 дней"></v-radio>
        <v-radio color="red" label="От 8 до 14 дней" value="От 8 до 14 дней"></v-radio>
        <v-radio color="red" label="Более 2 недель" value="Более 2 недель"></v-radio>
      </v-radio-group>


      <label class="custom_label" :class="this.novarollOrderMethods.length === 0 ? 'noValidError':''">4. Как вы обычно размещаете заказ в NOVAROLL?</label>
      <div class="mb-35 checkbox_group">
        <v-checkbox
            color="red"
            v-model="novarollOrderMethods"
            label="По телефону"
            value="По телефону"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="novarollOrderMethods"
            label="По электронной почте"
            value="По электронной почте"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="novarollOrderMethods"
            label="В мессенджерах"
            value="В мессенджерах"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="novarollOrderMethods"
            label="На онлайн-портале"
            value="На онлайн-портале"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="novarollOrderMethods"
            label="Другое (указать)"
            value="Другое"
        ></v-checkbox>
        <v-text-field
            class="different_el"
            v-if="novarollOrderMethods.includes('Другое')"
            v-model="novarollOrderMethodsOther"
            label="Укажите способ"
            color="red"
            placeholder="Ваш ответ..."
        ></v-text-field>
      </div>

      <label class="custom_label" :class="this.otherSuppliersOrderMethods.length === 0 ? 'noValidError':''">5. Как вы обычно размещаете заказ у других поставщиков?</label>
      <div class="mb-35 checkbox_group">
        <v-checkbox
            color="red"
            v-model="otherSuppliersOrderMethods"
            label="По телефону"
            value="По телефону"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="otherSuppliersOrderMethods"
            label="По электронной почте"
            value="По электронной почте"
        ></v-checkbox>
        <v-checkbox
            v-model="otherSuppliersOrderMethods"
            color="red"
            label="В мессенджерах"
            value="В мессенджерах"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="otherSuppliersOrderMethods"
            label="На онлайн-портале"
            value="На онлайн-портале"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="otherSuppliersOrderMethods"
            label="Другое (указать)"
            value="Другое"
        ></v-checkbox>
        <v-text-field
            class="different_el"
            v-if="otherSuppliersOrderMethods.includes('Другое')"
            v-model="otherSuppliersOrderMethodsOther"
            label="Укажите способ"
            color="red"
            placeholder="Ваш ответ..."
        ></v-text-field>
      </div>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="novarollOrderConvenience"
                     label="6. Насколько удобен для вас процесс размещения заказа в NOVAROLL?">
        <v-radio color="red" label="Очень удобно" value="Очень удобно"></v-radio>
        <v-radio color="red" label="Удобно" value="Удобно"></v-radio>
        <v-radio color="red" label="Не очень удобно" value="Не очень удобно"></v-radio>
        <v-radio color="red" label="Совсем неудобно" value="Совсем неудобно"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="otherSuppliersOrderConvenience"
                     label="7. Насколько удобен для вас процесс размещения заказа у других поставщиков?">
        <v-radio color="red" label="Очень удобно" value="Очень удобно"></v-radio>
        <v-radio color="red" label="Удобно" value="Удобно"></v-radio>
        <v-radio color="red" label="Не очень удобно" value="Не очень удобно"></v-radio>
        <v-radio color="red" label="Совсем неудобно" value="Совсем неудобно"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="orderTrackingConvenience"
                     label="8. Насколько вам удобно отслеживать статус вашего заказа NOVAROLL?">
        <v-radio color="red" label="Очень удобно" value="Очень удобно"></v-radio>
        <v-radio color="red" label="Удобно" value="Удобно"></v-radio>
        <v-radio color="red" label="Не очень удобно" value="Не очень удобно"></v-radio>
        <v-radio color="red" label="Совсем неудобно" value="Совсем неудобно"></v-radio>
      </v-radio-group>

      <!-- Пункт 9 -->
      <label class="custom_label" :class="this.paymentDifficulties.length === 0 ? 'noValidError':''">9. С какими трудностями вы сталкиваетесь при оплате заказов NOVAROLL?</label>
      <div class="mb-3 checkbox_group">
        <v-checkbox
            color="red"
            v-model="paymentDifficulties"
            label="Неудобен способ оплаты"
            value="Неудобен способ оплаты"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="paymentDifficulties"
            label="Задержки транзакций"
            value="Задержки транзакций"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="paymentDifficulties"
            label="Отсутствие информации о подтверждении платежа"
            value="Отсутствие информации о подтверждении платежа"
        ></v-checkbox>

        <v-checkbox
            color="red"
            v-model="paymentDifficulties"
            label="Другое (указать)"
            value="Другое"
        ></v-checkbox>
        <v-text-field
            class="different_el "
            v-if="paymentDifficulties.includes('Другое')"
            v-model="paymentDifficultiesText"
            label="Укажите вопрос"
            color="red"
            placeholder="Ваш ответ..."
        ></v-text-field>
      </div>
      <!-- Пункт 9 end-->

      <v-textarea
          placeholder="Ваш ответ..."
          color="red"
          v-model="orderPlacementProblems"
          label="10. Какие основные проблемы возникают при текущем способе размещения заказов в NOVAROLL? (укажите)"
          :rules="rulesFild"
          required=""
          rows="1"
          auto-grow
      ></v-textarea>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="orderPlacementTime"
                     label="11. Сколько времени в среднем уходит на размещение и получение подтверждения заказа NOVAROLL?">
        <v-radio color="red" label="Менее 5 минут" value="Менее 5 минут"></v-radio>
        <v-radio color="red" label="От 5 до 20 минут" value="От 5 до 20 минут"></v-radio>
        <v-radio color="red" label="Более 20 минут" value="Более 20 минут"></v-radio>
        <v-radio color="red" label="Другое (указать)" value="Другое"></v-radio>
      </v-radio-group>
      <v-text-field class="different_el" v-if="orderPlacementTime === 'Другое'" v-model="otherOrderPlacementTime" label="Укажите время"
                    color="red"></v-text-field>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="otherSuppliersOrderPlacementTime"
                     label="12. Сколько времени в среднем уходит на размещение и получение подтверждения заказа у других поставщиков?">
        <v-radio color="red" label="Менее 5 минут" value="Менее 5 минут"></v-radio>
        <v-radio color="red" label="От 5 до 20 минут" value="От 5 до 20 минут"></v-radio>
        <v-radio color="red" label="Более 20 минут" value="Более 20 минут"></v-radio>
        <v-radio color="red" label="Другое (указать)" value="Другое"></v-radio>
      </v-radio-group>
      <v-text-field class="different_el" v-if="otherSuppliersOrderPlacementTime === 'Другое'" v-model="otherSuppliersOrderPlacementTimeText"
                    label="Укажите время" color="red"             placeholder="Ваш ответ..."></v-text-field>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="usedOnlinePortal"
                     label="13. Пользовались ли вы когда-либо онлайн-порталом поставщика для заказа товаров в вашей работе?">
        <v-radio color="red" label="Да" value="Да"></v-radio>
        <v-radio color="red" label="Нет" value="Нет"></v-radio>
        <v-radio color="red" label="Затрудняюсь ответить" value="Затрудняюсь ответить"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="onlinePortalConvenience"
                     label="14. Насколько удобно вам было размещать заказ на онлайн-портале?">
        <v-radio color="red" label="Очень удобно" value="Очень удобно"></v-radio>
        <v-radio color="red" label="Удобно" value="Удобно"></v-radio>
        <v-radio color="red" label="Не очень удобно" value="Не очень удобно"></v-radio>
        <v-radio color="red" label="Совсем неудобно" value="Совсем неудобно"></v-radio>
        <v-radio color="red" label="Не пользуюсь" value="Не пользуюсь"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="ownOnlinePortals"
                     label="15. Используются ли в вашей компании собственные онлайн-порталы (платформы) для взаимодействия с поставщиками?">
        <v-radio color="red" label="Да" value="Да"></v-radio>
        <v-radio color="red" label="Нет" value="Нет"></v-radio>
        <v-radio color="red" label="Затрудняюсь ответить" value="Затрудняюсь ответить"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="wantOnlinePortal"
                     label="16. Удобно ли вам было бы размещать заказы в NOVAROLL на онлайн-портале на постоянной основе?">
        <v-radio color="red" label="Да" value="Да"></v-radio>
        <v-radio color="red" label="Нет" value="Нет"></v-radio>
        <v-radio color="red" label="Затрудняюсь ответить" value="Затрудняюсь ответить"></v-radio>
      </v-radio-group>

      <v-textarea
          placeholder="Ваш ответ..."
          color="red"
          v-model="portalFunctionality"
          label="17. Какой функционал для вас самый полезный при использовании онлайн-портала для заказа товаров? "
          rows="1"
          auto-grow
          :rules="rulesFild"
          required=""
      ></v-textarea>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="orderStatusNotifications"
                     label="18. Хотите ли вы получать уведомления об изменении статуса заказа по электронной почте или SMS?">
        <v-radio color="red" label="Да" value="Да"></v-radio>
        <v-radio color="red" label="Нет" value="Нет"></v-radio>
        <v-radio color="red" label="Затрудняюсь ответить" value="Затрудняюсь ответить"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="accessOrderHistory"
                     label="19. Нужен ли вам доступ к истории ваших предыдущих заказов?">
        <v-radio color="red" label="Да" value="Да"></v-radio>
        <v-radio color="red" label="Нет" value="Нет"></v-radio>
        <v-radio color="red" label="Затрудняюсь ответить" value="Затрудняюсь ответить"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="leaveFeedback"
                     label="20. Актуальна ли для вас возможность оставлять отзывы на портале после выполнения заказа?">
        <v-radio color="red" label="Да" value="Да"></v-radio>
        <v-radio color="red" label="Нет" value="Нет"></v-radio>
        <v-radio color="red" label="Затрудняюсь ответить" value="Затрудняюсь ответить"></v-radio>
      </v-radio-group>

      <v-radio-group   :rules="rulesFild"
          required="" v-model="contactSalesManagersFrequency"
                     label="21. Как часто вам приходится дополнительно обращаться к менеджерам по продажам для уточнения деталей заказа до момента его доставки?">
        <v-radio color="red" label="Никогда" value="Никогда"></v-radio>
        <v-radio color="red" label="Редко" value="Редко"></v-radio>
        <v-radio color="red" label="Очень часто" value="Очень часто"></v-radio>
        <v-radio color="red" label="Всегда" value="Всегда"></v-radio>
      </v-radio-group>

      <!--      <v-radio-group   :rules="rulesFild"
          required="" v-model="salesManagerQuestions"-->
      <!--                     label="22. Какие вопросы приходится уточнять у менеджера по продажам?">-->
      <!--        <v-radio color="red" label="Статус платежа" value="Статус платежа"></v-radio>-->
      <!--        <v-radio color="red" label="Статус готовности товара к отгрузке" value="Статус готовности товара к отгрузке"></v-radio>-->
      <!--        <v-radio color="red" label="Статус доставки" value="Статус доставки"></v-radio>-->
      <!--        <v-radio color="red" label="Не приходилось уточнять" value="Не приходилось уточнять"></v-radio>-->
      <!--        <v-radio color="red" label="Другое (указать)" value="Другое"></v-radio>-->
      <!--      </v-radio-group>-->

      <!-- Пункт 22 -->
      <label class="custom_label" :class="this.salesManagerQuestions.length === 0 ? 'noValidError':''">22. Какие вопросы приходится уточнять у менеджера по продажам?</label>
      <div class="mb-4 checkbox_group">
        <v-checkbox
            color="red"
            v-model="salesManagerQuestions"
            label="Статус платежа"
            value="Статус платежа"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="salesManagerQuestions"
            label="Статус готовности товара к отгрузке"
            value="Статус готовности товара к отгрузке"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="salesManagerQuestions"
            label="Статус доставки"
            value="Статус доставки"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="salesManagerQuestions"
            label="Не приходилось уточнять"
            value="Не приходилось уточнять"
        ></v-checkbox>
        <v-checkbox
            color="red"
            v-model="salesManagerQuestions"
            label="Другое (указать)"
            value="Другое"
        ></v-checkbox>
        <v-text-field
            class="different_el"
            v-if="salesManagerQuestions.includes('Другое')"
            v-model="salesManagerQuestionsOther"
            label="Укажите вопрос"
            color="red"
            placeholder="Ваш ответ..."
        ></v-text-field>
      </div>
      <!-- Пункт 22 end-->

      <v-textarea
          placeholder="Ваш ответ..."
          color="red"
          v-model="suggestionForImprovement"
          label="23. Если бы вы могли изменить что-то одно в существующей системе размещения и выполнения заказа, что бы вы улучшили? "
          :rules="rulesFild"
          required=""
          rows="1"
          auto-grow

      ></v-textarea>

      <v-textarea
          placeholder="Ваш ответ..."
          color="red"
          v-model="improvementSuggestions"
          label="24. Что бы вы хотели улучшить во взаимодействии с компанией NOVAROLL? "
          :rules="rulesFild"
          required=""
          rows="1"
          auto-grow
      ></v-textarea>

      <v-btn class="mt-30" @click.prevent="submitSurvey"  color="#f94237">Отправить</v-btn>
    </v-form>

  </div>
</template>

<script>
import VModalContents from "./modal_contents.vue";

export default {
  components: {VModalContents},
  props: {
    r: String | Number | Boolean,
  },
  data() {
    return {
      valid: false,

      validAll:true, // для оберточного класса
      companyName: '',
      cooperationDuration: null,
      orderFrequency: null,
      orderCycleTime: null,
      novarollOrderMethods: [],
      otherSuppliersOrderMethods: [],
      novarollOrderConvenience: null,

      novarollOrderMethodsOther: '',
      otherSuppliersOrderMethodsOther: '',

      otherSuppliersOrderConvenience: null,
      orderTrackingConvenience: null,
      paymentDifficulties: [],
      paymentDifficultiesText: '',

      orderPlacementProblems: '',
      orderPlacementTime: null,
      otherSuppliersOrderPlacementTime: null,
      usedOnlinePortal: null,
      onlinePortalConvenience: null,
      ownOnlinePortals: null,
      wantOnlinePortal: null,
      portalFunctionality: '',
      orderStatusNotifications: null,
      accessOrderHistory: null,
      leaveFeedback: null,
      contactSalesManagersFrequency: null,
      suggestionForImprovement: '',
      improvementSuggestions: '',


      products: [
        'Стрейч-пленку',
        'Клейкие ленты NOVAROLL',
        'Клейкие ленты UNIBOB'
      ],
      orderMethods: [
        'По телефону',
        'По электронной почте',
        'В мессенджерах',
        'На онлайн-портале',
        'Другое'
      ],
      // paymentIssues: [
      //   'Неудобен способ оплаты',
      //   'Задержки транзакций',
      //   'Отсутствие информации о подтверждении платежа',
      //   'Другие трудности (укажите)'
      // ],

      rulesFild: [
        (v) => !!v || "", //Поле не может быть пустым
        (v) => (v && v.length >= 1) || "", //Поле не может быть меньше 1 символа
      ],

      otherOrderPlacementTime: '',
      otherSuppliersOrderPlacementTimeText: '',

      salesManagerQuestions: [], // массив для хранения выбранных вопросов для чекбокса
      salesManagerQuestionsOther: '',

    };
  },
  methods: {
    submitSurvey() {

      // Проверка на валидность формы
      if (!this.$refs.form.validate()) {
        this.validAll = false;
        this.$refs.modal_alert.modal_open();
        return; // Прекращаем выполнение, если форма не валидна
      }

      // Проверка на заполненность чекбоксов
      if (
          this.novarollOrderMethods.length === 0 ||
          this.otherSuppliersOrderMethods.length === 0 ||
          this.paymentDifficulties.length === 0 ||
          this.salesManagerQuestions.length === 0
      ) {
        this.validAll = false;

        this.$refs.modal_alert.modal_open();
        return; // Прекращаем выполнение, если хотя бы один массив пустой
      }
      this.validAll = true;

      // if (!this.$refs.form.validate()) {
      //   this.$refs.modal_alert.modal_open()
      //
      // } else {
        let params = new URLSearchParams();

        const surveyData = {
          // companyName: this.companyName,
          cooperationDuration: this.cooperationDuration,
          orderFrequency: this.orderFrequency,
          orderCycleTime: this.orderCycleTime,
          novarollOrderMethods: this.novarollOrderMethods,
          novarollOrderMethodsOther: this.novarollOrderMethodsOther, //
          otherSuppliersOrderMethods: this.otherSuppliersOrderMethods,
          otherSuppliersOrderMethodsOther: this.otherSuppliersOrderMethodsOther, //
          novarollOrderConvenience: this.novarollOrderConvenience,
          otherSuppliersOrderConvenience: this.otherSuppliersOrderConvenience,
          orderTrackingConvenience: this.orderTrackingConvenience,
          paymentDifficulties: this.paymentDifficulties,
          paymentDifficultiesText: this.paymentDifficultiesText, //
          orderPlacementProblems: this.orderPlacementProblems,
          orderPlacementTime: this.orderPlacementTime,
          otherOrderPlacementTime: this.otherOrderPlacementTime,
          otherSuppliersOrderPlacementTime: this.otherSuppliersOrderPlacementTime,
          otherSuppliersOrderPlacementTimeText: this.otherSuppliersOrderPlacementTimeText,
          usedOnlinePortal: this.usedOnlinePortal,
          onlinePortalConvenience: this.onlinePortalConvenience,
          ownOnlinePortals: this.ownOnlinePortals,
          wantOnlinePortal: this.wantOnlinePortal,
          portalFunctionality: this.portalFunctionality,
          orderStatusNotifications: this.orderStatusNotifications,
          accessOrderHistory: this.accessOrderHistory,
          leaveFeedback: this.leaveFeedback,
          contactSalesManagersFrequency: this.contactSalesManagersFrequency,
          salesManagerQuestions: this.salesManagerQuestions,
          salesManagerQuestionsOther: this.salesManagerQuestionsOther,
          suggestionForImprovement: this.suggestionForImprovement,
          improvementSuggestions: this.improvementSuggestions,
          r: this.r,
        };

        params.set("ajaxPost", "Y");
        params.set("surveyData", JSON.stringify(surveyData));

        let url = "/ajax/survey.php";

        fetch(url, {method: "POST", body: params})
            .then(response => {
              // Обработка успешного ответа
              console.log('Опрос отправлен:', response.data);
              // Очистка формы или уведомление пользователя
              this.$refs.form.reset();
              this.$refs.modal_contents_successfully.modal_open(); //- вывод сообщения
            })
            .catch(error => {
              // Обработка ошибок
              console.error('Ошибка при отправке опроса:', error);
            });
      // }
      // if (!this.$refs.form.validate()) return false;


    }
  }
};
</script>

<style class="scss">
.wrapp_multiply {
  margin-top: 38px;
}
h2.modal_alert__title {
  font-size: 20px !important;
}
.poll .error--text {
  //margin-bottom: 8px;
}
.poll .v-input.error--text .v-text-field__slot label{
color: #ff5252 !important;
}
.noValid .noValidError {
  color: #ff5252 !important;
}
</style>

<style scoped>
.poll {

  .different_el.v-input--is-focused,
  .different_el.v-input--is-label-active {
    margin-top: 18px;
  }
  .checkbox_group {
    .v-text-field.different_el {
      margin-top: 18px;
    }
    .different_el.v-input--is-focused,
    .different_el.v-input--is-label-active {
      margin-top: 25px;
    }
  }
  .v-text-field.different_el {
    padding-top: 0;
  }

  .v-input.error--text .v-input--radio-group__input {
    //border: 1px solid red;
    width: auto;
  }
  .custom_label {
    font-size: 20px !important;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);

      @media (max-width: 500px) {
          font-size: 16px !important;
      }
  }

  label.v-label.theme--light {
    margin-bottom: 0;
  }

  .v-input--checkbox .v-messages.theme--light {
    display: none;
  }

  .v-input--selection-controls.v-input--checkbox {
    margin-top: 4px;
    padding-top: 4px;
  }

  & .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgba(0, 0, 0, .87) !important;
  }

  &.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    margin: 0;

  }

  & .v-input--radio-group legend.v-label {
    font-size: 20px !important;
    font-weight: 600;

    @media (max-width: 500px) {
      font-size: 16px !important;
    }
  }

  & .v-text-field .v-label {
    font-size: 20px !important;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6) !important;
    display: contents;
    white-space: unset;

    @media (max-width: 500px) {
      white-space: break-spaces;
      font-size: 16px !important;
    }
  }

  & .v-text-field .v-label.v-label--active {
    transform: translateY(-24px) scale(0.75) !important;
    display: block;
    white-space: nowrap;
  }

  & .v-btn {
    color: #FAFAFA;
  }

  & .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    font-size: 20px !important;
    @media (max-width: 500px) {
      font-size: 16px !important;
    }
  }

  & .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    display: block;
  }

  & .v-messages__message {
    font-size: 15px !important;
  }
}
</style>
